import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AccordionItem from 'componentsV2/AccordionItem';
import style from './Faq.module.scss';

const Faq = ({ faq = [], name = '', theme = {} }) => {
  if (!faq?.length) return null;
  return (
    <section className={classNames(style.container, theme.container)}>
      {name && <h3 className={classNames(style.title, theme.title)}>Getting to Know {name}</h3>}
      {faq.map(({ headline = '', body = '', id }) => (
        <AccordionItem headline={headline} body={body} key={id} />
      ))}
    </section>
  );
};

Faq.propTypes = {
  name: PropTypes.string.isRequired,
  faq: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  theme: PropTypes.shape({}),
};

export default Faq;
